// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gesammtunternehmenscreen{
  position: relative;
  
  /*TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}


/* SIDE SELECTOR START*/

.selector-container{
  position: relative;
  display: flex;
  flex-direction: row;
  top: 35px;
  height: fit-content;
  margin-right: 42px;
  margin-left: 42px;
  border-radius: 10px;
  background: var(--searchbar-background);

  /*Text Font*/
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.selector-item-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  background: var(--white-base);
  width: 100%;
  text-align: center; /* Center text within the flex container */
}

.selector-item-not-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  width: 100%;
  text-align: center; /* Center text within the flex container */
}
.selector-item-not-selected:hover {
  background-color: var(--gray-10);
}

.selector-divider {
  width: 1.48px;
  height: 50.8px;
  background-color: var(--gray-20);
  margin: 10px;
}
/* SIDE SELECTOR END */

/* MAIN CONTENT START*/
.gesammtunternehmen-content{
  position: relative;
  top: 80px;
  height: fit-content;
  display: flex;
  flex-direction: row;
  margin-left: var(--content-space);
  margin-right: var(--content-space);
}

.gesamt-left-content{
  position: relative;
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.gesamt-right-content{
  position: relative;
  width: 30%;
}

.bottom-content{
  position: relative;
  margin-left: var(--content-space);
  margin-right: var(--content-space);
  margin-top: 110px;
  margin-bottom: 20px;
}

/* MAIN CONTENT END*/

/* SLIDER START */
.gesammt-slider {
  position: relative;
  height: 250px;
  width: 100%;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--white-base);
}

.gesammt-slider-innercontainer{
  width: 90%;
  margin-left: 50px;
  margin-right: 50px;
}

.gesammt-slider-titlecontainer{
  display: flex;
  flex-direction: row;
  width: 100%;
}

.slider-header-container-gesamt{
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-left: 0px;
  margin-right: auto;
}

.slider-title-gesamt{
  margin-top: 20px;
  margin-left: 0px;
  margin-right: auto;
  /*TEXT FONT*/
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.slider-legend-gesamt {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: auto;
  align-self: center;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 0px;
  margin-right: auto;
  
  /* Text Font */
  font-size: 16px;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.12px;
}

.slider-title-smaller-gesamt {
  font-size: 20px;
  font-weight: 600;
}

.slider-legentitem-gesamt{  
  display: flex;
  margin-left: 40px;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.slider-legentitem-1{  
  border-radius: 50%;
  background-color: var(--indigo);
  width: 8px;
  height: 8px;
}
.slider-legentitem-2{  
  border-radius: 50%;
  background-color: var(--orange);
  width: 8px;
  height: 8px;
}
.slider-legentitem-3{  
  border-radius: 50%;
  background-color: var(--lime-green);
  width: 8px;
  height: 8px;
}

.slider-jahres-filter-gesamt{
  border-radius: 8px;
  background: var(--white-base);
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  height: fit-content;
  margin-left: 0px;
  margin-right: auto;
  /* Shadow */
  box-shadow: 0px 1px 5px 0px  var(--white-theme-gray-8);
}

.slider-Zielselection-filter-gesamt{
  border-radius: 8px;
  background: var(--white-base);
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  height: fit-content;
  margin-left: 0px;
  margin-right: auto;
  /* Shadow */
  box-shadow: 0px 1px 5px 0px var(--white-theme-gray-8);
}

.slider-container1{
  width: 100%;
  margin-bottom: 60px;
}

.filtercontainer{
  margin: 0px 10px;
}

/* SLIDER END */

.ziele-definieren-button{
  border-radius: 18px;
  background: var(--color-forestgreen);
  margin-top: 18px;
  margin-left: 20px;
  margin-right: 0px;
  width: fit-content;
  min-width: 200px;
  height: fit-content;
  cursor: pointer;

  /* TEXT FONT*/
  
  color: var(--white-base);
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700; 
}
.ziele-definieren-button:hover{
  transform: scale(1.01);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); 
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}

.level-field-feedback{
  border-radius: 18px;
  background: var(--color-forestgreen);
  margin-top: 18px;
  margin-left: 20px;
  margin-right: 0px;
  width: fit-content;
  min-width: 200px;
  height: fit-content;

  /* TEXT FONT*/
  
  color: var(--white-base);
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700; 
}
/* WAS BEDEUTET START*/

.gesammt-info{
  margin-top: 50px;
  width: 100%;
  border-radius: 12px;
  height: 100%;
  border: 1px solid var(--border);
}

/* WAS BEDEUTET END */

/* CARD CONTAINER START*/

.card-maincontainer{
  margin-top: 20px;
  border-radius: 12px;
  padding: 10px;
  border: 1px solid var(--border);
}

.card-title-container{
  display: flex;
  flex-direction: row;
  margin: 0px 20px;
}

.card-title{
  font-weight: 600;
  line-height: 32px;
  margin-right: auto;
  margin-top: 20px;
  /* TEXT FONT */
  font-size: 25px;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: -0.56px;
}

.card-container {
  width: 100%;
  height: 690px;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-top: 15px;
  background: var(--white-base);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-around;
}

.card {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(15%); /* Adjust the percentage to control the number of cards per row */
  width: 100%; /* Make the width 100% for flexibility */
  height: 400px; /* Make the height 100% for consistency */
  margin: 10px; /* Adjust the margin between cards */
  box-sizing: border-box;
  overflow-y: hidden;
  border-radius: 15px;
  padding-bottom: 20px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  transition: box-shadow 0.3s ease;
  border: 1px solid var(--borderColor);
}

/* Optional: Adjustments for smaller screens */
@media (max-width: 768px) {
  .card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

/* Optional: Adjustments for even smaller screens */
@media (max-width: 480px) {
  .card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
}

.card:hover {
  cursor: pointer;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

.card img {
  display: block;
  margin: 0 auto;
  width: 60%;
  object-fit: contain;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding: 10px;
  margin-top: 20px;
}

.card-content-line {
  margin-top: 40px;
  display: block;
  height: 2px;
  width: 90%;
  background-color: rgba(50, 50, 50, 0.7);
  margin: 0 auto;
}

.card-content {
  padding: 20px;
  max-height: 58%;
  overflow-y: scroll;
  padding-bottom: 10px;
  font-size: var(--inter-body-1-medium-size);
}

.card-text-title {
  letter-spacing: 0.12px;
  line-height: 20px;
  white-space: pre-wrap;
  font-weight: 500;
  display: inline-block;
  font-weight: bold;
}

.card-text-content {
  letter-spacing: 0.12px;
  line-height: 20px;
  white-space: pre-wrap;
  display: inline-block;
}

.card-content::-webkit-scrollbar,
.card-container::-webkit-scrollbar {
  width: 5px;
}
/* CARD CONTAINER END*/

/* DIGITAL INDEX RADIALCHART START */
.di-box{
  position: relative;
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  height: 100%;
  border: 1px solid var(--border);

  /* TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}

.di-title{
  margin: 15px auto;
  width: fit-content;
  text-align: center;

  /* TEXT FONT*/
  font-size: 34px;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: -0.56px;
}

.di-content{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.di-radialchart-container {
  position: relative;
  width: 100%;
  min-height: 300px;
}

.di-info-title{
  font-weight: 600;
  line-height: 32px;
  /* TEXT FONT */  
  font-size: 25px;
}

.di-legend{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;

  /* TEXT FONT */  
  font-size: 16px;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.12px;
}

.di-info-container{
  border-radius: 12px;
  border: 1px solid var(--border);
  margin: 24px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 250px;
}
.di-info-text{
  margin: 0px 20px;
}

/* DIGITAL INDEX RADIALCHART END */


/* OVERLAY PROJEKTE-SELECTOR START */
.project-content{
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 30%;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.project-content-line{  
  margin-top: 10px;
  display: block;
  height: 3px;
  width: 90%;
  background-color: rgba(50, 50, 50, 0.7);
  margin: 0 auto;
}

.project-select-container {
  display: flex;
  flex-direction: column;
  height: 300px;
  margin: 20px auto; /* Updated margin property */
  width: fit-content;
  padding: 20px;
  padding-bottom: 0px;
  overflow-y: scroll;
}

.project-choice {
  display: flex;
  align-items: center; /* Center vertically */  
}

.project-choice input[type="checkbox"] {
  appearance: none;
  width: 20px; /* Adjust the size as needed */
  height: 20px; /* Adjust the size as needed */
  margin-right: 10px; /* Adjust spacing between checkbox and text */
  border: 2px solid var(--blue-60); /* Border color */
  background-color: white; /* Background color when unchecked */
  cursor: pointer;
}

.project-choice input[type="checkbox"]:checked {
  background-color: var(--blue-60); /* Background color when checked */
  border-color: var(--blue-60); /* Border color when checked */
}


.project-selector-Projectname{
  display: flex;
  flex-direction: row;
  margin: 10px 50px;  
}

.project-button-container{
  padding: 0px 30px;
  display:flex;
}

.project-selector-cancel-button{
  position: relative;
  width: fit-content;
  height: fit-content;
  background: var(--blue-60);
  cursor: pointer;

  /* TEXT FONT*/
  text-align: center;
  color: var(--white-base);
  padding: 0px 20px;
  font-weight: 700;
  line-height: 30px;
  border-radius: 99px;
  border: var(--blue-60);

  /* Hover effect */
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.project-selector-cancel-button:hover {
  background: var(--blue-50); /* Change the background color on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a box shadow to simulate a pressed-down look */
}

.project-selector-confirm-button{
  position: relative;
  width: fit-content;
  height: fit-content;
  background: var(--blue-60);
  cursor: pointer;
  margin-right: 0px;
  margin-left: auto;

  /* TEXT FONT*/
  text-align: center;
  color: var(--white-base);
  padding: 0px 20px;
  font-weight: 700;
  line-height: 30px;
  border-radius: 99px;
  border: var(--blue-60);
  align-self: center;

  /* Hover effect */
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.project-selector-confirm-button:hover {
  background: var(--blue-50); /* Change the background color on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a box shadow to simulate a pressed-down look */
}

/* OVERLAY PROJEKTE-SELECTOR END */


/* OVERLAY PROJEKTE START */
.overlay-projekt {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  cursor: default;
}

.overlay-content {
  background: #fff;
  border-radius: 10px;
  cursor: default;
  padding: 20px;
  width: 30%;
  text-align: center;
  display: flex;
  min-height: 500px;
  flex-direction: column;
}

.overlay-content:hover {
  cursor: default;
}

.overlay-top {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  width: 100%; /* Take the full width of the content */
}

.overlay-icon {
  width: 90px;
  height: 90px;
  margin-right: 10px;
}

.overlay-title {
  margin-left: 20px;
  text-align: left;
  margin-right: auto; /* Push the title to the left */

  /* TEXT FONT */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}

.overlay-title h2 {
  font-weight: bold;
  margin: 0;
}@media (min-width: 300px) {
  .overlay-title h2 {
    font-size: 60%; /* Adjust the percentage as needed */
  }
}

.overlay-title-r {
  text-align: right; /* Align the investment title to the right */
  margin-left: auto; /* Push the investment title to the right */
}

.overlay-title-r h2 {
  font-size: 18px; /* Adjust the font size for the investment title */
  font-weight: normal; /* Make it normal weight */
  margin: 0;
}

.overlay-categories {
  font-size: 14px;
  font-style: italic;
  color: #555;
}

.overlay-categories-r {
  font-size: 16px; /* Adjust the font size for investment value */
  font-weight: bold; /* Make it bold */
  margin: 0;
}

.overlay-description {
  text-align: left; /* Set text alignment to left */
  max-height: 400px;
  overflow-y: scroll;
  margin-top: 15px;
  font-size: 16px;
  min-height: 300px;
}

.project-selector-back-button{
  position: relative;
  width: fit-content;
  height: fit-content;
  background: var(--blue-60);
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  margin-top: auto;
  /* TEXT FONT*/
  text-align: center;
  color: var(--white-base);
  padding: 0px 20px;
  font-weight: 700;
  line-height: 30px;
  border-radius: 99px;
  border: var(--blue-60);
  align-self: center;

  /* Hover effect */
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.project-selector-back-button:hover {
  background: var(--blue-50); /* Change the background color on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a box shadow to simulate a pressed-down look */
}
/* OVERLAY PROJEKTE END */


/* ADD NEW PROJECT START */
.add-new-project-top-container{
  align-items: baseline;
  display: flex;
  flex-direction: row;
  gap: 1px;
}

.add-new-project-icon{
  align-self: center;
}

.add-new-project-title-container{
  display: flex;
  width: fit-content;
  flex-direction: column;
  margin: 0px 5px auto 0px;
}

.add-new-project-title-container h2{
  align-self: baseline;
  margin-top: 0px;
  /* TEXT FONT */
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
}

.add-new-project-title {
  border-radius: 10px;
  max-width: 260px;
  margin-top: -15px;
  margin-bottom: 10px;
  border: 2px solid var(--gray-20);
  outline: none;
  border: none;

  /* TEXT FONT */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;  
}

.add-new-project-selector{
  width: fit-content;
  border-radius: 10px;
  border: 2px solid var(--gray-20); /* Slightly gray border */
  transition: border-color 0.3s ease; /* Smooth transition effect */
  margin-bottom: 6px;
  margin-top: -10px;

  /* TEXT FONT */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;  
}

.add-new-project-title-r h2{
  /* TEXT FONT */
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
}

.add-new-project-invest{
  width: 87%;
  margin-right: 1px;
  border-radius: 10px;
  border: 2px solid var(--gray-20); /* Slightly gray border */
  transition: border-color 0.3s ease; /* Smooth transition effect */
  margin-bottom: 10px;
  outline: none;
  border: none;

  /* TEXT FONT */
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;  
}

.add-new-project-level{
  width: 53%;
  text-align: center;
  border-radius: 10px;
  border: 2px solid var(--gray-20); /* Slightly gray border */
  transition: border-color 0.3s ease; /* Smooth transition effect */
  outline: none;
  border: none;
  
  /* TEXT FONT */
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;  
}

.add-new-project-textarea-container{
  text-align: left;
  height: 100%;
}

.add-new-project-textarea{
  width: 99%;
  height: 260px;
  max-width: 99%;
  max-height: 254px;

  border-radius: 10px;
  border: 2px solid var(--gray-20); /* Slightly gray border */
  transition: border-color 0.3s ease; /* Smooth transition effect */
  
  /* TEXT FONT */
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;  
}

.add-new-project-button-container {
  margin-top: auto;
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 600px;
}

.add-new-project-button {
  position: relative;
  width: fit-content;
  height: fit-content;
  background: var(--blue-60);
  cursor: pointer;

  /* TEXT FONT*/
  text-align: center;
  color: var(--white-base);
  padding: 0px 20px;
  font-weight: 700;
  line-height: 30px;
  border-radius: 99px;
  border: var(--blue-60);
  align-self: center;

  /* Hover effect */
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.add-new-project-button:hover {
  background: var(--blue-50);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.add-new-project-button-right {
  margin-left: auto;
}

.add-new-project-button-left {
  margin-right: auto;
}

/* ADD NEW PROJECT END */`, "",{"version":3,"sources":["webpack://./src/pages/StrategieGesamtunternehmen.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;;EAEvC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;AACA,sBAAsB;;AAEtB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,oBAAoB;;AAEpB,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;;EAElB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;;EAEf,aAAa;;EAEb,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,aAAa;;EAEb,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA,sBAAsB;;AAEtB;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA,qBAAqB;;AAErB,wBAAwB;;AAExB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,YAAmB;EAAnB,cAAmB;EAAnB,qBAAmB,EAAE,iEAAiE;EACtF,WAAW,EAAE,wCAAwC;EACrD,aAAa,EAAE,yCAAyC;EACxD,YAAY,EAAE,oCAAoC;EAClD,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;EACvC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,8CAA8C;AAC9C;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,UAAU;EACV,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;AACZ;AACA,sBAAsB;;AAEtB,oCAAoC;AACpC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;;EAE/B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;;EAElB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;;EAEnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;;;AAGlC,oCAAoC;AACpC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,UAAU;EACV,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB,EAAE,4BAA4B;EAC/C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,gBAAgB;EAChB,WAAW,EAAE,8BAA8B;EAC3C,YAAY,EAAE,8BAA8B;EAC5C,kBAAkB,EAAE,6CAA6C;EACjE,gCAAgC,EAAE,iBAAiB;EACnD,uBAAuB,EAAE,oCAAoC;EAC7D,eAAe;AACjB;;AAEA;EACE,gCAAgC,EAAE,kCAAkC;EACpE,4BAA4B,EAAE,8BAA8B;AAC9D;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;;EAEf,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;;EAEtB,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,0BAA0B,EAAE,yCAAyC;EACrE,wCAAwC,EAAE,qDAAqD;AACjG;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;;EAEjB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;;EAElB,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,0BAA0B,EAAE,yCAAyC;EACrE,wCAAwC,EAAE,qDAAqD;AACjG;;AAEA,kCAAkC;;;AAGlC,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW,EAAE,uCAAuC;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB,EAAE,+BAA+B;;EAEnD,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX,CAAC;EACC;IACE,cAAc,EAAE,oCAAoC;EACtD;AACF;;AAEA;EACE,iBAAiB,EAAE,4CAA4C;EAC/D,iBAAiB,EAAE,2CAA2C;AAChE;;AAEA;EACE,eAAe,EAAE,kDAAkD;EACnE,mBAAmB,EAAE,0BAA0B;EAC/C,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe,EAAE,8CAA8C;EAC/D,iBAAiB,EAAE,iBAAiB;EACpC,SAAS;AACX;;AAEA;EACE,gBAAgB,EAAE,+BAA+B;EACjD,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;;EAElB,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,0BAA0B,EAAE,yCAAyC;EACrE,wCAAwC,EAAE,qDAAqD;AACjG;AACA,yBAAyB;;;AAGzB,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,YAAY;;EAEZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC,EAAE,yBAAyB;EAC3D,kCAAkC,EAAE,6BAA6B;EACjE,kBAAkB;EAClB,iBAAiB;;EAEjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC,EAAE,yBAAyB;EAC3D,kCAAkC,EAAE,6BAA6B;EACjE,mBAAmB;EACnB,aAAa;EACb,YAAY;;EAEZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC,EAAE,yBAAyB;EAC3D,kCAAkC,EAAE,6BAA6B;EACjE,aAAa;EACb,YAAY;;EAEZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,iBAAiB;;EAEjB,mBAAmB;EACnB,gCAAgC,EAAE,yBAAyB;EAC3D,kCAAkC,EAAE,6BAA6B;;EAEjE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;;EAEf,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;;EAElB,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wBAAwB","sourcesContent":[".gesammtunternehmenscreen{\r\n  position: relative;\r\n  \r\n  /*TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n\r\n\r\n/* SIDE SELECTOR START*/\r\n\r\n.selector-container{\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  top: 35px;\r\n  height: fit-content;\r\n  margin-right: 42px;\r\n  margin-left: 42px;\r\n  border-radius: 10px;\r\n  background: var(--searchbar-background);\r\n\r\n  /*Text Font*/\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.selector-item-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  background: var(--white-base);\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n\r\n.selector-item-not-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n.selector-item-not-selected:hover {\r\n  background-color: var(--gray-10);\r\n}\r\n\r\n.selector-divider {\r\n  width: 1.48px;\r\n  height: 50.8px;\r\n  background-color: var(--gray-20);\r\n  margin: 10px;\r\n}\r\n/* SIDE SELECTOR END */\r\n\r\n/* MAIN CONTENT START*/\r\n.gesammtunternehmen-content{\r\n  position: relative;\r\n  top: 80px;\r\n  height: fit-content;\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-left: var(--content-space);\r\n  margin-right: var(--content-space);\r\n}\r\n\r\n.gesamt-left-content{\r\n  position: relative;\r\n  width: 70%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.gesamt-right-content{\r\n  position: relative;\r\n  width: 30%;\r\n}\r\n\r\n.bottom-content{\r\n  position: relative;\r\n  margin-left: var(--content-space);\r\n  margin-right: var(--content-space);\r\n  margin-top: 110px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* MAIN CONTENT END*/\r\n\r\n/* SLIDER START */\r\n.gesammt-slider {\r\n  position: relative;\r\n  height: 250px;\r\n  width: 100%;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n}\r\n\r\n.gesammt-slider-innercontainer{\r\n  width: 90%;\r\n  margin-left: 50px;\r\n  margin-right: 50px;\r\n}\r\n\r\n.gesammt-slider-titlecontainer{\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n}\r\n\r\n.slider-header-container-gesamt{\r\n  display: flex;\r\n  width: 100%;\r\n  flex-direction: row;\r\n  margin-left: 0px;\r\n  margin-right: auto;\r\n}\r\n\r\n.slider-title-gesamt{\r\n  margin-top: 20px;\r\n  margin-left: 0px;\r\n  margin-right: auto;\r\n  /*TEXT FONT*/\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.slider-legend-gesamt {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: auto;\r\n  align-self: center;\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n  margin-left: 0px;\r\n  margin-right: auto;\r\n  \r\n  /* Text Font */\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.12px;\r\n}\r\n\r\n.slider-title-smaller-gesamt {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.slider-legentitem-gesamt{  \r\n  display: flex;\r\n  margin-left: 40px;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.slider-legentitem-1{  \r\n  border-radius: 50%;\r\n  background-color: var(--indigo);\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n.slider-legentitem-2{  \r\n  border-radius: 50%;\r\n  background-color: var(--orange);\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n.slider-legentitem-3{  \r\n  border-radius: 50%;\r\n  background-color: var(--lime-green);\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.slider-jahres-filter-gesamt{\r\n  border-radius: 8px;\r\n  background: var(--white-base);\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  align-self: center;\r\n  height: fit-content;\r\n  margin-left: 0px;\r\n  margin-right: auto;\r\n  /* Shadow */\r\n  box-shadow: 0px 1px 5px 0px  var(--white-theme-gray-8);\r\n}\r\n\r\n.slider-Zielselection-filter-gesamt{\r\n  border-radius: 8px;\r\n  background: var(--white-base);\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  align-self: center;\r\n  height: fit-content;\r\n  margin-left: 0px;\r\n  margin-right: auto;\r\n  /* Shadow */\r\n  box-shadow: 0px 1px 5px 0px var(--white-theme-gray-8);\r\n}\r\n\r\n.slider-container1{\r\n  width: 100%;\r\n  margin-bottom: 60px;\r\n}\r\n\r\n.filtercontainer{\r\n  margin: 0px 10px;\r\n}\r\n\r\n/* SLIDER END */\r\n\r\n.ziele-definieren-button{\r\n  border-radius: 18px;\r\n  background: var(--color-forestgreen);\r\n  margin-top: 18px;\r\n  margin-left: 20px;\r\n  margin-right: 0px;\r\n  width: fit-content;\r\n  min-width: 200px;\r\n  height: fit-content;\r\n  cursor: pointer;\r\n\r\n  /* TEXT FONT*/\r\n  \r\n  color: var(--white-base);\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-family: Inter;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700; \r\n}\r\n.ziele-definieren-button:hover{\r\n  transform: scale(1.01);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); \r\n  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.level-field-feedback{\r\n  border-radius: 18px;\r\n  background: var(--color-forestgreen);\r\n  margin-top: 18px;\r\n  margin-left: 20px;\r\n  margin-right: 0px;\r\n  width: fit-content;\r\n  min-width: 200px;\r\n  height: fit-content;\r\n\r\n  /* TEXT FONT*/\r\n  \r\n  color: var(--white-base);\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-family: Inter;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700; \r\n}\r\n/* WAS BEDEUTET START*/\r\n\r\n.gesammt-info{\r\n  margin-top: 50px;\r\n  width: 100%;\r\n  border-radius: 12px;\r\n  height: 100%;\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n/* WAS BEDEUTET END */\r\n\r\n/* CARD CONTAINER START*/\r\n\r\n.card-maincontainer{\r\n  margin-top: 20px;\r\n  border-radius: 12px;\r\n  padding: 10px;\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.card-title-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin: 0px 20px;\r\n}\r\n\r\n.card-title{\r\n  font-weight: 600;\r\n  line-height: 32px;\r\n  margin-right: auto;\r\n  margin-top: 20px;\r\n  /* TEXT FONT */\r\n  font-size: 25px;\r\n  font-weight: 700;\r\n  line-height: 44px;\r\n  letter-spacing: -0.56px;\r\n}\r\n\r\n.card-container {\r\n  width: 100%;\r\n  height: 690px;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n  margin-top: 15px;\r\n  background: var(--white-base);\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n  justify-content: space-around;\r\n}\r\n\r\n.card {\r\n  flex: 0 0 calc(15%); /* Adjust the percentage to control the number of cards per row */\r\n  width: 100%; /* Make the width 100% for flexibility */\r\n  height: 400px; /* Make the height 100% for consistency */\r\n  margin: 10px; /* Adjust the margin between cards */\r\n  box-sizing: border-box;\r\n  overflow-y: hidden;\r\n  border-radius: 15px;\r\n  padding-bottom: 20px;\r\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);\r\n  transition: box-shadow 0.3s ease;\r\n  border: 1px solid var(--borderColor);\r\n}\r\n\r\n/* Optional: Adjustments for smaller screens */\r\n@media (max-width: 768px) {\r\n  .card {\r\n    flex: 0 0 calc(50% - 20px);\r\n    max-width: calc(50% - 20px);\r\n  }\r\n}\r\n\r\n/* Optional: Adjustments for even smaller screens */\r\n@media (max-width: 480px) {\r\n  .card {\r\n    flex: 0 0 calc(100% - 20px);\r\n    max-width: calc(100% - 20px);\r\n  }\r\n}\r\n\r\n.card:hover {\r\n  cursor: pointer;\r\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.card img {\r\n  display: block;\r\n  margin: 0 auto;\r\n  width: 60%;\r\n  object-fit: contain;\r\n  border-top-left-radius: 15px;\r\n  border-top-right-radius: 15px;\r\n  padding: 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.card-content-line {\r\n  margin-top: 40px;\r\n  display: block;\r\n  height: 2px;\r\n  width: 90%;\r\n  background-color: rgba(50, 50, 50, 0.7);\r\n  margin: 0 auto;\r\n}\r\n\r\n.card-content {\r\n  padding: 20px;\r\n  max-height: 58%;\r\n  overflow-y: scroll;\r\n  padding-bottom: 10px;\r\n  font-size: var(--inter-body-1-medium-size);\r\n}\r\n\r\n.card-text-title {\r\n  letter-spacing: 0.12px;\r\n  line-height: 20px;\r\n  white-space: pre-wrap;\r\n  font-weight: 500;\r\n  display: inline-block;\r\n  font-weight: bold;\r\n}\r\n\r\n.card-text-content {\r\n  letter-spacing: 0.12px;\r\n  line-height: 20px;\r\n  white-space: pre-wrap;\r\n  display: inline-block;\r\n}\r\n\r\n.card-content::-webkit-scrollbar,\r\n.card-container::-webkit-scrollbar {\r\n  width: 5px;\r\n}\r\n/* CARD CONTAINER END*/\r\n\r\n/* DIGITAL INDEX RADIALCHART START */\r\n.di-box{\r\n  position: relative;\r\n  margin-left: 50px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 12px;\r\n  height: 100%;\r\n  border: 1px solid var(--border);\r\n\r\n  /* TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n\r\n.di-title{\r\n  margin: 15px auto;\r\n  width: fit-content;\r\n  text-align: center;\r\n\r\n  /* TEXT FONT*/\r\n  font-size: 34px;\r\n  font-weight: 700;\r\n  line-height: 44px;\r\n  letter-spacing: -0.56px;\r\n}\r\n\r\n.di-content{\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.di-radialchart-container {\r\n  position: relative;\r\n  width: 100%;\r\n  min-height: 300px;\r\n}\r\n\r\n.di-info-title{\r\n  font-weight: 600;\r\n  line-height: 32px;\r\n  /* TEXT FONT */  \r\n  font-size: 25px;\r\n}\r\n\r\n.di-legend{\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n\r\n  /* TEXT FONT */  \r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 24px; /* 150% */\r\n  letter-spacing: 0.12px;\r\n}\r\n\r\n.di-info-container{\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  margin: 24px 0px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 250px;\r\n}\r\n.di-info-text{\r\n  margin: 0px 20px;\r\n}\r\n\r\n/* DIGITAL INDEX RADIALCHART END */\r\n\r\n\r\n/* OVERLAY PROJEKTE-SELECTOR START */\r\n.project-content{\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  width: 30%;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.project-content-line{  \r\n  margin-top: 10px;\r\n  display: block;\r\n  height: 3px;\r\n  width: 90%;\r\n  background-color: rgba(50, 50, 50, 0.7);\r\n  margin: 0 auto;\r\n}\r\n\r\n.project-select-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 300px;\r\n  margin: 20px auto; /* Updated margin property */\r\n  width: fit-content;\r\n  padding: 20px;\r\n  padding-bottom: 0px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.project-choice {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */  \r\n}\r\n\r\n.project-choice input[type=\"checkbox\"] {\r\n  appearance: none;\r\n  width: 20px; /* Adjust the size as needed */\r\n  height: 20px; /* Adjust the size as needed */\r\n  margin-right: 10px; /* Adjust spacing between checkbox and text */\r\n  border: 2px solid var(--blue-60); /* Border color */\r\n  background-color: white; /* Background color when unchecked */\r\n  cursor: pointer;\r\n}\r\n\r\n.project-choice input[type=\"checkbox\"]:checked {\r\n  background-color: var(--blue-60); /* Background color when checked */\r\n  border-color: var(--blue-60); /* Border color when checked */\r\n}\r\n\r\n\r\n.project-selector-Projectname{\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin: 10px 50px;  \r\n}\r\n\r\n.project-button-container{\r\n  padding: 0px 30px;\r\n  display:flex;\r\n}\r\n\r\n.project-selector-cancel-button{\r\n  position: relative;\r\n  width: fit-content;\r\n  height: fit-content;\r\n  background: var(--blue-60);\r\n  cursor: pointer;\r\n\r\n  /* TEXT FONT*/\r\n  text-align: center;\r\n  color: var(--white-base);\r\n  padding: 0px 20px;\r\n  font-weight: 700;\r\n  line-height: 30px;\r\n  border-radius: 99px;\r\n  border: var(--blue-60);\r\n\r\n  /* Hover effect */\r\n  transition: background 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.project-selector-cancel-button:hover {\r\n  background: var(--blue-50); /* Change the background color on hover */\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a box shadow to simulate a pressed-down look */\r\n}\r\n\r\n.project-selector-confirm-button{\r\n  position: relative;\r\n  width: fit-content;\r\n  height: fit-content;\r\n  background: var(--blue-60);\r\n  cursor: pointer;\r\n  margin-right: 0px;\r\n  margin-left: auto;\r\n\r\n  /* TEXT FONT*/\r\n  text-align: center;\r\n  color: var(--white-base);\r\n  padding: 0px 20px;\r\n  font-weight: 700;\r\n  line-height: 30px;\r\n  border-radius: 99px;\r\n  border: var(--blue-60);\r\n  align-self: center;\r\n\r\n  /* Hover effect */\r\n  transition: background 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.project-selector-confirm-button:hover {\r\n  background: var(--blue-50); /* Change the background color on hover */\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a box shadow to simulate a pressed-down look */\r\n}\r\n\r\n/* OVERLAY PROJEKTE-SELECTOR END */\r\n\r\n\r\n/* OVERLAY PROJEKTE START */\r\n.overlay-projekt {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 1000;\r\n  cursor: default;\r\n}\r\n\r\n.overlay-content {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  cursor: default;\r\n  padding: 20px;\r\n  width: 30%;\r\n  text-align: center;\r\n  display: flex;\r\n  min-height: 500px;\r\n  flex-direction: column;\r\n}\r\n\r\n.overlay-content:hover {\r\n  cursor: default;\r\n}\r\n\r\n.overlay-top {\r\n  display: flex;\r\n  margin-bottom: 10px;\r\n  align-items: center;\r\n  width: 100%; /* Take the full width of the content */\r\n}\r\n\r\n.overlay-icon {\r\n  width: 90px;\r\n  height: 90px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.overlay-title {\r\n  margin-left: 20px;\r\n  text-align: left;\r\n  margin-right: auto; /* Push the title to the left */\r\n\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 32px;\r\n}\r\n\r\n.overlay-title h2 {\r\n  font-weight: bold;\r\n  margin: 0;\r\n}@media (min-width: 300px) {\r\n  .overlay-title h2 {\r\n    font-size: 60%; /* Adjust the percentage as needed */\r\n  }\r\n}\r\n\r\n.overlay-title-r {\r\n  text-align: right; /* Align the investment title to the right */\r\n  margin-left: auto; /* Push the investment title to the right */\r\n}\r\n\r\n.overlay-title-r h2 {\r\n  font-size: 18px; /* Adjust the font size for the investment title */\r\n  font-weight: normal; /* Make it normal weight */\r\n  margin: 0;\r\n}\r\n\r\n.overlay-categories {\r\n  font-size: 14px;\r\n  font-style: italic;\r\n  color: #555;\r\n}\r\n\r\n.overlay-categories-r {\r\n  font-size: 16px; /* Adjust the font size for investment value */\r\n  font-weight: bold; /* Make it bold */\r\n  margin: 0;\r\n}\r\n\r\n.overlay-description {\r\n  text-align: left; /* Set text alignment to left */\r\n  max-height: 400px;\r\n  overflow-y: scroll;\r\n  margin-top: 15px;\r\n  font-size: 16px;\r\n  min-height: 300px;\r\n}\r\n\r\n.project-selector-back-button{\r\n  position: relative;\r\n  width: fit-content;\r\n  height: fit-content;\r\n  background: var(--blue-60);\r\n  cursor: pointer;\r\n  margin-left: 0px;\r\n  margin-right: auto;\r\n  margin-top: auto;\r\n  /* TEXT FONT*/\r\n  text-align: center;\r\n  color: var(--white-base);\r\n  padding: 0px 20px;\r\n  font-weight: 700;\r\n  line-height: 30px;\r\n  border-radius: 99px;\r\n  border: var(--blue-60);\r\n  align-self: center;\r\n\r\n  /* Hover effect */\r\n  transition: background 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.project-selector-back-button:hover {\r\n  background: var(--blue-50); /* Change the background color on hover */\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add a box shadow to simulate a pressed-down look */\r\n}\r\n/* OVERLAY PROJEKTE END */\r\n\r\n\r\n/* ADD NEW PROJECT START */\r\n.add-new-project-top-container{\r\n  align-items: baseline;\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 1px;\r\n}\r\n\r\n.add-new-project-icon{\r\n  align-self: center;\r\n}\r\n\r\n.add-new-project-title-container{\r\n  display: flex;\r\n  width: fit-content;\r\n  flex-direction: column;\r\n  margin: 0px 5px auto 0px;\r\n}\r\n\r\n.add-new-project-title-container h2{\r\n  align-self: baseline;\r\n  margin-top: 0px;\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n}\r\n\r\n.add-new-project-title {\r\n  border-radius: 10px;\r\n  max-width: 260px;\r\n  margin-top: -15px;\r\n  margin-bottom: 10px;\r\n  border: 2px solid var(--gray-20);\r\n  outline: none;\r\n  border: none;\r\n\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 32px;  \r\n}\r\n\r\n.add-new-project-selector{\r\n  width: fit-content;\r\n  border-radius: 10px;\r\n  border: 2px solid var(--gray-20); /* Slightly gray border */\r\n  transition: border-color 0.3s ease; /* Smooth transition effect */\r\n  margin-bottom: 6px;\r\n  margin-top: -10px;\r\n\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 500;  \r\n}\r\n\r\n.add-new-project-title-r h2{\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n}\r\n\r\n.add-new-project-invest{\r\n  width: 87%;\r\n  margin-right: 1px;\r\n  border-radius: 10px;\r\n  border: 2px solid var(--gray-20); /* Slightly gray border */\r\n  transition: border-color 0.3s ease; /* Smooth transition effect */\r\n  margin-bottom: 10px;\r\n  outline: none;\r\n  border: none;\r\n\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 32px;  \r\n}\r\n\r\n.add-new-project-level{\r\n  width: 53%;\r\n  text-align: center;\r\n  border-radius: 10px;\r\n  border: 2px solid var(--gray-20); /* Slightly gray border */\r\n  transition: border-color 0.3s ease; /* Smooth transition effect */\r\n  outline: none;\r\n  border: none;\r\n  \r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 32px;  \r\n}\r\n\r\n.add-new-project-textarea-container{\r\n  text-align: left;\r\n  height: 100%;\r\n}\r\n\r\n.add-new-project-textarea{\r\n  width: 99%;\r\n  height: 260px;\r\n  max-width: 99%;\r\n  max-height: 254px;\r\n\r\n  border-radius: 10px;\r\n  border: 2px solid var(--gray-20); /* Slightly gray border */\r\n  transition: border-color 0.3s ease; /* Smooth transition effect */\r\n  \r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 32px;  \r\n}\r\n\r\n.add-new-project-button-container {\r\n  margin-top: auto;\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n  max-width: 600px;\r\n}\r\n\r\n.add-new-project-button {\r\n  position: relative;\r\n  width: fit-content;\r\n  height: fit-content;\r\n  background: var(--blue-60);\r\n  cursor: pointer;\r\n\r\n  /* TEXT FONT*/\r\n  text-align: center;\r\n  color: var(--white-base);\r\n  padding: 0px 20px;\r\n  font-weight: 700;\r\n  line-height: 30px;\r\n  border-radius: 99px;\r\n  border: var(--blue-60);\r\n  align-self: center;\r\n\r\n  /* Hover effect */\r\n  transition: background 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.add-new-project-button:hover {\r\n  background: var(--blue-50);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.add-new-project-button-right {\r\n  margin-left: auto;\r\n}\r\n\r\n.add-new-project-button-left {\r\n  margin-right: auto;\r\n}\r\n\r\n/* ADD NEW PROJECT END */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
